export const AUTHENTICATION_MODULE_NAME = 'authentication'
export const ALERT_MODULE_NAME = 'alert'
export const STUDIO_MODULE_NAME = 'studio'
export const CUSTOM_FIELDS_MODULE_NAME = 'customFields'
